var SubscriptionUpdateSourceEnum;
(function (SubscriptionUpdateSourceEnum) {
    SubscriptionUpdateSourceEnum["ACCOUNT_DASHBOARD"] = "ACCOUNT_DASHBOARD";
    SubscriptionUpdateSourceEnum["REACTIVATION_WIZARD"] = "REACTIVATION_WIZARD";
    SubscriptionUpdateSourceEnum["CANCELLATION_WIZARD"] = "CANCELLATION_WIZARD";
})(SubscriptionUpdateSourceEnum || (SubscriptionUpdateSourceEnum = {}));
export default SubscriptionUpdateSourceEnum;
//# sourceMappingURL=SubscriptionUpdateSourceEnum.js.map